//
//  src/layouts/default/error/ErrorNotFound.js
//
import * as React from "react";
import { Helmet } from "react-helmet";
import { useLocation, Link } from "react-router-dom";
import Nav from "../../../components/nav/Nav";
import Footer from "../../../components/footer/Footer";


//
//  error not found
//
export default function ErrorNotFound() {
    const location = useLocation();
    const canonicalUrl = `https://jefftattooer.com${location.pathname}`.replace(/\/$/, '') || 'https://jefftattooer.com';
    const ogImage = 'https://jefftattooer.com/logo512.png';
    const pageTitle = '404 - Page Not Found | Jeff Tattooer';
    const pageDescription = 'The page you are looking for could not be found.';
    
    return (
        <div id="notfound">
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <link rel="canonical" href={canonicalUrl} />
                
                {/* Open Graph */}
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:image" content={ogImage} />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Jeff Tattooer" />
                
                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={pageDescription} />
                <meta name="twitter:image" content={ogImage} />
            </Helmet>
            <Nav />
            <div className="container" style={{ textAlign: 'center', padding: '100px 0', minHeight: '60vh' }}>
                <h1>404</h1>
                <h4>Page Not Found</h4>
                <p>The page you're looking for doesn't exist.</p>
                <br />
                <Link to="/" className="btn waves-effect waves-light orange">
                    Go Home
                </Link>
            </div>
            <Footer />
        </div>
    );
}

